// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"6de2e080","453":"20359781","626":"b7012195","651":"950ea899"}[chunkId] + ".chunk.js";
};